<template>
  <div>
    <div class="book-list">
      <div class="demo-book-box" v-for="(item, index) in dataList" :key="index">
        <div class="left-book">
          <img
            :src="item.cover || require('@/assets/images/default_img.jpg')"
            alt=""
            @click="toDetail(item)"
          />
        </div>
        <div class="right-book-info">
          <div class="book-title">
            <div class="book-label" v-if="item.sourceFile">
              {{ item.sourceFile }}
            </div>
            <div
              class="el-tooltip title"
              tabindex="0"
              @click="toDetail(item)"
              v-html="
                eachColor(
                  item.goodsTitle,
                  searchName,
                  $store.state.read.searchText
                )
              "
            ></div>
          </div>
          <div
            class="author-p"
            v-if="
              item.goodsType != 'paper' &&
              item.goodsType != 'looseleafOrtextbook' &&
              item.goodsType != 'train'
            "
          >
            作者：<span v-if="item.author"> {{ item.author }}</span>
            <span v-if="!item.author">-</span>
          </div>
          <div v-if="item.goodsType == 'train'" class="author-p">
            讲师：{{ item.lecturer || "-" }}
          </div>
          <div
            class="author-p"
            v-if="item.instName && item.goodsType == 'train'"
          >
            提供机构：{{ item.instName || "-" }}
          </div>
          <div
            class="author-p"
            v-if="item.publishingHouse && item.goodsType != 'train'"
          >
            提供机构：{{ item.publishingHouse || "-" }}
          </div>
          <div class="label" v-if="item.keyword != null">
            <span
              v-for="(item, index) in item.keyword.split(',')"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <div class="price">
            {{ item.realPrice | tofixed2("￥") }}
            <span
              v-if="item.prices > 0"
              :class="item.prices == 0 ? 'yprice2' : 'yprice'"
              >{{ item.prices | tofixed2("￥") }}</span
            >
          </div>
          <!-- <div class="editor-l">编辑推荐语：</div> -->
          <p>
            {{
              item.authorRecommendation == null ||
              item.authorRecommendation == ""
                ? ""
                : item.authorRecommendation
            }}
          </p>
        </div>
      </div>
    </div>
    <noData v-if="total == 0"></noData>
    <div class="pagination-box" v-show="total > 0">
      <el-pagination
        class="ou-pagination"
        background
        hide-on-single-page
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryParams.pageSize"
        layout="total, prev, pager, next, sizes, jumper, slot"
        :total="total"
      >
        <el-button @click="getList()" class="ou-page-go">GO</el-button>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { selectBooks } from "@/api/index/index";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      dataList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  props: {
    searchName: String,
    eachColor: Function,
  },
  components: {
    noData,
  },
  methods: {
    getList(word = undefined) {
      //获取教学属性列表
      var Params = {
        ...this.queryParams,
        word2: word || undefined,
        word1: this.$store.state.read.searchText || undefined,
      };
      selectBooks(Params).then((res) => {
        this.dataList = res.rows;
        this.total = res.total;
        this.$emit("settotal", "tstotal", res.total);
      });
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    toDetail(item) {
      if (item.goodsType == "train") {
        this.$router.push({
          path: "/willingLearn/bookstoreDetail",
          query: {
            goodsId: item.goodsId,
            goodsType: item.goodsType,
          },
        });
      } else {
        this.$router.push({
          path: "/bookstore/bookstoreDetail",
          query: {
            goodsId: item.goodsId,
            goodsType: item.goodsType,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.book-list .demo-book-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  /* align-items: center; */
  padding-bottom: 15px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 15px;
}

.book-list .demo-book-box .left-book {
  width: 260px;
  height: 260px;
  background: #fbfbfb;
  border: 1px solid #f2f2f2;
  border-radius: 6px;
  margin-right: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
}

.book-list .demo-book-box .left-book img {
  /* max-width: 100%;
  max-height: 100%;
  -o-object-fit: scale-down;
  object-fit: scale-down; */
  width: 100%;
  height: 100%;
}

.book-list .demo-book-box .right-book-info {
  width: calc(100% - 310px);
}

.book-list .demo-book-box .right-book-info .book-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 24px;
  margin-bottom: 20px;
}

.book-list .demo-book-box .right-book-info .book-title .book-label {
  /* padding: 0 11px; */
  width: 60px;
  box-sizing: border-box;
  height: 24px;
  background: #f9fdff;
  border: 1px solid #0081ce;
  border-radius: 6px;
  text-align: center;
  line-height: 24px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
  margin-right: 10px;
}

.book-list .demo-book-box .right-book-info .book-title .title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  max-width: 600px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.book-list .demo-book-box .right-book-info .author-p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-bottom: 14px;
}

.book-list .demo-book-box .right-book-info .author-p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-bottom: 14px;
}

.book-list .demo-book-box .right-book-info .label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 25px;
  flex-wrap: wrap;
}

.book-list .demo-book-box .right-book-info .label span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  background: #f2f2f2;
  border-radius: 6px;
  padding: 7px 10px;
  margin-right: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: block;
  margin-bottom: 8px;
}

.book-list .demo-book-box .right-book-info .label span:last-child {
  margin-right: 0;
}

.book-list .demo-book-box .right-book-info .price {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff5353;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 19px;
}

.book-list .demo-book-box .right-book-info .price .yprice {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  text-decoration: line-through;
  color: #999999;
  margin-left: 10px;
}

.book-list .demo-book-box .right-book-info .price .yprice2 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  text-decoration: line-through;
  margin-left: 10px;
}
.book-list .demo-book-box .right-book-info .editor-l {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-bottom: 14px;
}

.book-list .demo-book-box .right-book-info p {
  width: 750px;
  font-size: 14px;
  line-height: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.book-list .demo-book-box .right-book-info .book-title .title:hover {
  color: #1690ff;
  text-decoration: underline;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
::v-deep .book-list .demo-book-box .right-book-info p {
  width: 100%;
}
</style>
